export const dayOptionsMocked = [
  'Todos os dias',
  'Terça',
  'Quarta',
  'Quinta',
  'Sexta',
  'Sábado',
  'Domingo',
];
